import React, { useState } from 'react';
import styles from '../landing.module.scss';

import exploreImg from '../../../assets/images/landing/how-it-works.png';
import optimizeImg from '../../../assets/images/landing/hero-dashboard.png';
import monitorImg from '../../../assets/images/landing/how-it-works.png';

const HowItWorks = () => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      title: "Explore",
      description: "Analyze trending games, categories, revenue signals, and competitors to spot market opportunities.",
      image: exploreImg
    },
    {
      title: "Optimize",
      description: "Find high-impact keywords, track rankings, and improve your store's visibility.",
      image: optimizeImg
    },
    {
      title: "Monitor",
      description: "Track your progress and adjust as needed.",
      image: monitorImg
    }
  ];

  return (
    <section className={styles.howItWorksSection} id="how-it-works">
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>How It Works</h2>

        <div className={styles.howItWorksContent}>

          {/* Steps */}
          <div className={styles.stepsList}>
            {steps.map((step, index) => (
              <div
                key={index}
                className={`${styles.stepItem} ${activeStep === index ? styles.active : ''}`}
                onClick={() => setActiveStep(index)}
              >
                <h3>{step.title}</h3>
                {activeStep === index && (
                  <>
                    <p>{step.description}</p>

                    {/* MOBILE IMAGE */}
                    <div className={styles.mobileStepImage}>
                      <img
                        src={step.image}
                        alt={step.title}
                        className={styles.howItWorksImage}
                      />
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>

          {/* DESKTOP IMAGE */}
          <div className={styles.stepImage}>
            <div className={styles.imagePlaceholder}>
              <img
                key={activeStep}
                src={steps[activeStep].image}
                alt={steps[activeStep].title}
                className={styles.howItWorksImage}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HowItWorks;


// import React, { useState } from 'react';
// import styles from '../landing.module.scss';
// import howItWorksImg from '../../../assets/images/landing/how-it-works.png';

// const HowItWorks = () => {
//     const [activeStep, setActiveStep] = useState(0);
//     const steps = [
//         { title: "Explore", description: "Analyze trending games, categories, revenue signals, and competitors to spot market opportunities." },
//         { title: "Optimize", description: "Find high-impact keywords, track rankings, and improve your store's visibility." },
//         { title: "Monitor", description: "Track your progress and adjust as needed." }
//     ];

//     return (
//         <section className={styles.howItWorksSection} id="how-it-works">
//             <div className={styles.container}>
//                 <h2 className={styles.sectionTitle}>How It Works</h2>
//                 <div className={styles.howItWorksContent}>
//                     <div className={styles.stepsList}>
//                         {steps.map((step, index) => (
//                             <div
//                                 key={index}
//                                 className={`${styles.stepItem} ${activeStep === index ? styles.active : ''}`}
//                                 onClick={() => setActiveStep(index)}
//                             >
//                                 <h3>{step.title}</h3>
//                                 {activeStep === index && <p>{step.description}</p>}
//                             </div>
//                         ))}
//                     </div>
//                     <div className={styles.stepImage}>
//                         <div className={styles.imagePlaceholder}>
//                             <img src={howItWorksImg} alt={`Step ${activeStep + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '12px' }} />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default HowItWorks;
